/**
 * A global namespace for 'removeEventListener' string.
 */
const removeEventListener = 'removeEventListener';
export default removeEventListener;
